import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root"
})
export class LocaleConverterService {
  //#region Albania Locale Options
  private readonly locale = "sq-AL";
  private readonly currencyStyle = { style: "currency", currency: "LEK" };

  //#endregion

  public formatMoney(money: number): string {
    return new Intl.NumberFormat(this.locale, this.currencyStyle).format(money);
  }

  public formatDate(date: string, options?: any): string {
    return new Intl.DateTimeFormat(this.locale, options).format(new Date(date));
  }

  public formatForBootstrapDateInput(date: string): string {
    return new Date(date).toLocaleDateString("en-CA", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit"
    });
  }
}
